import React from 'react';
import _ from 'lodash';
import { Box, FormControl, FormHelperText, InputLabel, Select, MenuItem, Typography, OutlinedInput, TextField, Autocomplete } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { RequiredField } from '../others/RequiredField';
import { useDynamicAction, useDynamicQuery, useDynamicFunction, useFullScreen } from '../../services/hooks';
import { constructDependsOnParams, getDependsOnValue, handleShowOn, handleDynamicFunction } from '../../services/functions';
import { InfoField } from './InfoField';
import { WarningDialog } from '../WarningDialog';

export const ChoiceField = props => {
  const { field, formik, updateOptionsCallback, getFieldCallback, setLoadingCallback, searchParams,
    handleDiscountActions, handleParishChange, handleEventChange, handlePeriodChange,
    handleSourceOfOfferChange, params, formVersion, initialParamsData, handleAccomodationChange,
    metaData } = props;
  const mediaWidth = useFullScreen() ? '300px' : '100%';
  const [open, setOpen] = React.useState(false);
  const [resortParameterValIsSet, setResortParameterValIsSet] = React.useState(false);
  const [periodParameterValIsSet, setPeriodParameterValIsSet] = React.useState(false);
  const [packageParameterValIsSet, setPackageParameterValIsSet] = React.useState(false);
  const [sourceOfOfferParameterValIsSet, setSourceOfOfferParameterValIsSet] = React.useState(false);
  const [schoolProvinceParameterValIsSet, setSchoolProvinceParameterValIsSet] = React.useState(false);
  const [schoolCountyParameterValIsSet, setSchoolCountyParameterValIsSet] = React.useState(false);
  const [schoolCommuneParameterValIsSet, setSchoolCommuneParameterValIsSet] = React.useState(false);
  const [schoolCityParameterValIsSet, setSchoolCityParameterValIsSet] = React.useState(false);
  const [schoolNameParameterValIsSet, setSchoolNameParameterValIsSet] = React.useState(false);
  const seasonYear = formVersion.toString().substring(0, 4);
  const [openWarningDialog, setOpenWarningDialog] = React.useState(false);
  const [manualSeasonalPromotionIsSet, setManualSeasonalPromotionIsSet] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (field.disabled) {
      return;
    }
    setOpen(true);
  };

  const action = useDynamicAction(
    field.depends_on,
    field.on_change,
    constructDependsOnParams(field.depends_on, field.name, formik.values, [], formVersion
    ),
    formik.values[field.name],
    searchParams
  );
  const { query, data, loading } = useDynamicQuery(action);
  const dynamicFunction = useDynamicFunction(field.on_change_splitted ? field.on_change_splitted[0] : field.on_change);
  const [description, setDescription] = React.useState('');

  React.useEffect(() => {
    if (data.camp && params.camp) {
      Reflect.deleteProperty(data, 'camp');
    }
    updateOptionsCallback(data);
  }, [data]);

  React.useEffect(() => {
    setLoadingCallback(loading);
  }, [loading]);

  const handleChange = (value, v, initialization = false) => {
    formik.setFieldValue(field.name, value);
    let sections = null;
    if (!_.isNil(dynamicFunction)) {
      const res = handleDynamicFunction(dynamicFunction, formik, field, value);
      if (res.callback) {
        sections = props[res.callback](res.data, field.options.indexOf(value), value);
      }
    }
    if (field.name == 'discount') {
      handleDiscountActions(value, sections);
    } else if (field.name == 'parish') {
      handleParishChange(value);
    } else if (field.name == 'event') {
      handleEventChange(value);
      const selectedOption = field.dynamicOptions.filter(o => o.id == value)[0];
      if (selectedOption && selectedOption.birth_date_from && selectedOption.birth_date_to) {
        const birthDateFrom = new Date(selectedOption.birth_date_from);
        const birthDateTo = new Date(selectedOption.birth_date_to);
        const participantBirthDate = new Date(formik.values.birth_date);
        if (!participantBirthDate || participantBirthDate < birthDateFrom || participantBirthDate > birthDateTo) {
          setOpenWarningDialog(true);
        };
      };
    } else if (field.name == 'source_of_offer') {
      handleSourceOfOfferChange(field.options.filter(o => o.id == value)[0]);
    } else if (field.name == 'accomodation') {
      handleAccomodationChange(value, field);
    }
    if (field.name == 'period') {
      return handlePeriodChange(v, sections, initialization);
    }
    if (!value) {
      return;
    }
    if (!_.isNil(v.props)) {
      if (v.props['data-description']) {
        setDescription(v.props['data-description']);
      }
    }
    if (!_.isNil(action)) {
      query();
    }
  };

  React.useEffect(() => {
    if (field.name == 'resort' && initialParamsData.resort && field.dynamicOptions) {
      formik.setFieldValue('resort', initialParamsData.resort.toString());
    }
  }, [initialParamsData, field.dynamicOptions]);

  React.useEffect(() => {
    if (initialParamsData.resort && field.name == 'resort' && formik.values.resort && !resortParameterValIsSet) {
      handleChange(initialParamsData.resort.toString(), { props: {} });
      setResortParameterValIsSet(true);
    }
  }, [formik.values.resort]);

  React.useEffect(() => {
    if (initialParamsData.period && field.name == 'period' && field.dynamicOptions && field.dynamicOptions.length > 0 && !periodParameterValIsSet) {
      setTimeout(() => {
        const name = field.dynamicOptions.filter(item => item.id == initialParamsData.period)[0].name;
        handleChange(initialParamsData.period.toString(), { props: { id: name } }, true);
        setPeriodParameterValIsSet(true);
      }, 200);
    }
    if (initialParamsData.package && field.name == 'package' && field.dynamicOptions && field.dynamicOptions.length > 0 && !packageParameterValIsSet) {
      const name = field.dynamicOptions.filter(item => item.id == initialParamsData.package)[0].name;
      handleChange(initialParamsData.package.toString(), { props: { id: name } });
      setPackageParameterValIsSet(true);
    }
    if (initialParamsData.source_of_offer && field.name == 'source_of_offer' && field.options && field.options.length > 0 && !sourceOfOfferParameterValIsSet) {
      const name = field.options.filter(item => item.id == initialParamsData.source_of_offer)[0].name;
      handleChange(initialParamsData.source_of_offer.toString(), { props: { id: name } });
      setSourceOfOfferParameterValIsSet(true);
    }
    if (seasonYear > 2025) {
      if (initialParamsData.school_province && field.name == 'school_province' && field.dynamicOptions && field.dynamicOptions.length > 0 && !schoolProvinceParameterValIsSet) {
        const schoolProvinceName = field.dynamicOptions.filter(item => item.id == initialParamsData.school_province)[0].name;
        handleChange(initialParamsData.school_province.toString(), { props: { id: schoolProvinceName } });
        setSchoolProvinceParameterValIsSet(true);
      }
      if (initialParamsData.school_county && field.name == 'school_county' && field.dynamicOptions && field.dynamicOptions.length > 0 && !schoolCountyParameterValIsSet) {
        const name = field.dynamicOptions.filter(item => item.id == initialParamsData.school_county)[0].name;
        handleChange(initialParamsData.school_county.toString(), { props: { id: name } });
        setSchoolCountyParameterValIsSet(true);
      }
      if (initialParamsData.school_commune && field.name == 'school_commune' && field.dynamicOptions && field.dynamicOptions.length > 0 && !schoolCommuneParameterValIsSet) {
        const name = field.dynamicOptions.filter(item => item.id == initialParamsData.school_commune)[0].name;
        handleChange(initialParamsData.school_commune.toString(), { props: { id: name } });
        setSchoolCommuneParameterValIsSet(true);
      }
      if (initialParamsData.school_city && field.name == 'school_city' && field.dynamicOptions && field.dynamicOptions.length > 0 && !schoolCityParameterValIsSet) {
        const name = field.dynamicOptions.filter(item => item.id == initialParamsData.school_city)[0].name;
        handleChange(initialParamsData.school_city.toString(), { props: { id: name } });
        setSchoolCityParameterValIsSet(true);
      }
      if (initialParamsData.school_name && field.name == 'school_name' && field.dynamicOptions && field.dynamicOptions.length > 0 && !schoolNameParameterValIsSet) {
        const name = field.dynamicOptions.filter(item => item.id == initialParamsData.school_name)[0].name;
        handleChange(initialParamsData.school_name.toString(), { props: { id: name } });
        setSchoolNameParameterValIsSet(true);
      }
    }
  }, [field.dynamicOptions]);

  React.useEffect(() => {
    if (
      ['seasonal_promotion'].includes(field.name) &&
      field.dynamicOptions?.length
    ) {
      const option = field.dynamicOptions[0];

      const selectedPromotionsIds = [
        ...formik.values.ol_discounts,
        ...formik.values.discount_code_promotions
      ].filter(Boolean);

      const selectedPromotions = metaData.promotions.filter(p => selectedPromotionsIds.includes(p.id)
      );
      const shouldDisableSeasonal = selectedPromotions.some(sp => !sp.is_seasonal_combined);
      const current = formik.values[field.name];
      if (shouldDisableSeasonal && current !== '') {
        formik.setFieldValue(field.name, '');
        setManualSeasonalPromotionIsSet(true);

        return;
      }
      if (!shouldDisableSeasonal && current !== option.id) {
        formik.setFieldValue(field.name, option.id);
      }
    }
  }, [formik.values.ol_discounts, formik.values.discount_code_promotions, field.dynamicOptions]);

  React.useEffect(() => {
    if (['quick_payment_promotion_obj'].includes(field.name) && field.dynamicOptions && field.dynamicOptions.length > 0) {
      const option = field.dynamicOptions[0];
      if (formik.values[field.name] != option.id) {
        formik.setFieldValue(field.name, option.id);
      }
    }
    if (['seasonal_promotion'].includes(field.name) && field.dynamicOptions && field.dynamicOptions.length > 0) {
      if (manualSeasonalPromotionIsSet) {
        return;
      }
      const option = field.dynamicOptions[0];
      if (formik.values[field.name] != option.id) {
        formik.setFieldValue(field.name, option.id);
      }
    }
  }, [field.dynamicOptions]);

  return (
    <>
      <Box style={{ display: field.hide ? 'none' : handleShowOn(
        field.show_on, formik.values,
        getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []), field.show_on_condition ? field.show_on_condition : 'OR')
        ? ''
        : 'none' }}>
        <Typography variant="subtitle1" >
          <b>{field.label}</b>
          <RequiredField required={field.required} isEmpty={_.isNumber(formik.values[field.name]) ? false : _.isEmpty(formik.values[field.name])} formikError={formik.touched[field.name] && Boolean(formik.errors[field.name])} />
        </Typography>
        <FormControl
          style={{ marginBottom: 15, maxWidth: mediaWidth }}
          fullWidth
          variant="outlined"
          error={formik.touched[field.name] && Boolean(formik.errors[field.name])}>
          {field.depends_on && _.isEmpty(formik.values[getDependsOnValue(field.depends_on)]) && _.isEmpty(field.dynamicOptions)
            ? <Typography color="error">{field.additional_info}</Typography>
            : (
              <>
                <InputLabel htmlFor={field.name}>{_.isEmpty(formik.values[field.name]) ? field.label : null}</InputLabel>
                {field.autocomplete ? (
                  <Autocomplete
                    fullWidth
                    disableClearable
                    open={open}
                    onOpen={handleOpen}
                    onClose={handleClose}
                    getOptionLabel={option => (typeof option === 'string' ? option : option.name)}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    options={field.dynamicOptions || field.options || []}

                    value={(() => {
                      if (!formik.values[field.name]) {
                        return null;
                      }
                      const allOptions = field.dynamicOptions || field.options || [];

                      return allOptions.find(o => o.id == formik.values[field.name]) || null;
                    })()}
                    onChange={(_, value) => formik.setFieldValue(field.name, value.id)}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label={field.label}
                        variant="outlined"
                        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}
                      />
                    )}
                  />
                ) : (
                  <Select
                    input={<OutlinedInput id={field.name} label={_.isEmpty(formik.values[field.name]) ? field.label : null} />}
                    sx={{
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'primary.light'
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'primary.main'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'primary.dark'
                      }
                    }}
                    labelId={field.name}
                    value={formik.values[field.name] || ''}
                    onChange={(e, v) => handleChange(e.target.value, v)}
                    open={open}
                    onOpen={handleOpen}
                    onClose={handleClose}
                    name={field.label}
                    id="qwe"
                    disabled={field.disabled}
                    IconComponent={_props => {
                      const rotate = _props.className.toString().includes('iconOpen');

                      return (
                        <div>
                          {rotate
                            ? <div style={{ color: 'red', cursor: 'pointer', marginRight: 5, marginBottom: 5, fontSize: 20 }}>X</div>
                            : <div><KeyboardArrowDownIcon style={{ cursor: 'pointer' }} onClick={handleOpen} /></div>}
                        </div>
                      );
                    }}
                  >
                    <MenuItem value="">&nbsp;</MenuItem>
                    {Array.isArray(field.dynamicOptions || field.options) &&
                      (field.dynamicOptions || field.options).map((item, key) => {
                        const isObject = typeof item === 'object' && item !== null;

                        return (
                          <MenuItem
                            style={{ whiteSpace: 'normal' }}
                            key={key}
                            value={isObject ? item.id : item}
                            id={isObject ? item.name : item}
                            data-description={isObject ? item.description : ''}
                          >
                            {isObject ? item.name : item}
                          </MenuItem>
                        );
                      })
                    }
                  </Select>
                )}

                <Typography color="green">{description}</Typography>
                {
                  !_.isEmpty(field.infos)
                    ? _.map(field.infos, (info, key) => {
                      if (info.no_choices) {
                        return <Typography key={key} color={info.color}>
                          {!_.isNil(formik.values[field.name])
                            ? !_.isNil(field.dynamicOptions)
                              ? field.dynamicOptions.length > 0
                                ? null
                                : info.label
                              : info.label
                            : info.label}
                        </Typography>;
                      }
                    })
                    : null
                }

              </>
            )
          }
          <FormHelperText>{formik.touched[field.name] && formik.errors[field.name]}</FormHelperText>
          {
            !_.isEmpty(field.infos)
              ? _.map(field.infos, (info, key) => {
                if (info.no_choices === false) {
                  return <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} infoDynamicText={field.infos.length == key + 1 ? data?.info_field : undefined}/>;
                }
              })
              : null
          }
        </FormControl>
      </Box>
      <WarningDialog
        title="Uwaga!"
        open={openWarningDialog}
        setOpen={setOpenWarningDialog}
        onConfirm={() => {
          formik.setFieldValue(field.name, '');
        }}
      >
        <Typography>{'Wybrana impreza jest przeznaczona dla uczestników innego przedziału wiekowego'}</Typography>
      </WarningDialog>
    </>
  );
};
